export default "__VITE_ASSET__gCldoMi1__"